function Home() {
  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-background px-6">
      {/* Subtle radial gradient background */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(0,0,0,0.03)_0%,_transparent_70%)] dark:bg-[radial-gradient(ellipse_at_center,_rgba(255,255,255,0.04)_0%,_transparent_70%)]" />

      {/* Content  changed*/}
      <div className="relative z-10 flex flex-col items-center gap-8 max-w-2xl text-center">
        {/* Logo mark */}
        <div className="flex items-center justify-center w-14 h-14 rounded-2xl bg-foreground">
          <span className="text-2xl font-black text-background tracking-tight">
            sf
          </span>
        </div>

        {/* Headline */}
        <div className="flex flex-col gap-4">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-black tracking-tight leading-[1.1] text-foreground">
            AI Customer Support.{" "}
            <span className="text-muted-foreground">Built for you.</span>
          </h1>
          <p className="text-lg sm:text-xl text-muted-foreground max-w-lg mx-auto leading-relaxed">
            Create your own customer support chatbots and voice assistants using
            SmallForce — no code required.
          </p>
        </div>

        {/* CTA */}
        <a
          href="https://smallforcehq.com"
          className="group inline-flex items-center gap-2.5 rounded-full bg-foreground px-7 py-3.5 text-sm font-semibold text-background transition-all duration-200 hover:opacity-90 hover:scale-[1.02] active:scale-[0.98]"
        >
          Get Started
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="transition-transform duration-200 group-hover:translate-x-0.5"
          >
            <path d="M5 12h14" />
            <path d="m12 5 7 7-7 7" />
          </svg>
        </a>

        {/* Subtle footer mark */}
        <p className="text-xs text-muted-foreground/50 mt-4 tracking-wide uppercase">
          smallforcehq.com
        </p>
      </div>
    </div>
  );
}

export default Home;
